import { render } from "./Tech.vue?vue&type=template&id=675cb874"
import script from "./Tech.vue?vue&type=script&lang=js"
export * from "./Tech.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__